type ContentTabsProps = {
  currentTab: 'active' | 'archived';
  activeCount: number;
  archivedCount: number;
  setCurrentTab: (_tab: 'active' | 'archived') => void;
};

export function ContentTabs({
  currentTab,
  activeCount,
  archivedCount,
  setCurrentTab,
}: ContentTabsProps) {
  return (
    <div className="cp-tabs" role="tablist" aria-label="Content views">
      <button
        type="button"
        role="tab"
        aria-selected={currentTab === 'active'}
        className={`cp-tab ${currentTab === 'active' ? 'cp-tab--active' : ''}`}
        onClick={() => setCurrentTab('active')}
      >
        Active
        <span className="cp-tab__count">{activeCount}</span>
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={currentTab === 'archived'}
        className={`cp-tab ${currentTab === 'archived' ? 'cp-tab--active' : ''}`}
        onClick={() => setCurrentTab('archived')}
      >
        Archived
        <span className="cp-tab__count">{archivedCount}</span>
      </button>
    </div>
  );
}
